import { Radio as MuiRadio } from "@mui/material";

import { RadioLabel } from "ui/radio/radio.styles";
import { type RadioProps } from "ui/radio/radio.types";
import { useRadio } from "ui/radio/use-radio";

export const Radio = ({
  value,
  checked,
  onChange,
  label,
  ref,
  sx,
  className,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  ...rest
}: RadioProps) => {
  const { handleChange } = useRadio({ value, onChange });
  const hasLabel = label !== undefined;

  const control = (
    <MuiRadio
      {...rest}
      className={hasLabel ? undefined : className}
      sx={hasLabel ? undefined : sx}
      value={value}
      checked={checked}
      onChange={handleChange}
      slotProps={{ input: { ref, "aria-label": ariaLabel, "data-testid": dataTestId } }}
    />
  );

  if (!hasLabel) {
    return control;
  }

  return <RadioLabel className={className} control={control} label={label} sx={sx} />;
};
